/**
 * 使用方法
 * <CollapseTable data={this.state.tableCollapse} />
 * tableCollapse: {
    struct: [
        { title: '', key: 'collapse', width: 80 },
        { title: '姓名', key: 'name', width: 200 },
        { title: '手机号码', key: 'phone', width: 200 }
    ],
    data: [
        {
            name: 'hello1',
            phone: '18768112222',
            subData: (d, i) => {
                return <div className="table-inner-wrap">
                    我是嵌套的内容
                </div>
            }
        },
    ],
    showSubData: false
}
 * struct增加一列，key为collapse
 * data子项中，有subData则有嵌套内容，subData为一个函数
 * showSubData为默认嵌套内容是否全部展开，true为全展开，false为全隐藏，不传为全隐藏
 * <ListView tableCollapse={true}/>
 */
var React = require('react');
var css = require('./table.scss');
var Table = require('./table.js');
const $ = require('jquery');

var CollapseTable = React.createClass({
    getInitialState: function () {
        return {
            showSubDataArr: []
        };
    },
    componentWillReceiveProps: function (nextProps) {
        var data = this.props.data;
        var showSubDataArr = [];
        for (var i = 0; i < data.data.length; i++) {
            if (data.showSubData) {
                showSubDataArr.push(true);
            } else {
                showSubDataArr.push(false);
            }
        }
        this.setState({
            showSubDataArr: showSubDataArr
        });
    },
    toggleRow: function (i) {
        this.state.showSubDataArr[i] = !this.state.showSubDataArr[i];
        this.setState();
    },
    render: function () {
        let tableWrapWidth;
        var cls = ['fp-table-fixed-head'];
        var data = this.props.data;
        var rowStyle = this.props.rowStyle;
        var style = {};
        var colGroups = [];
        data.struct.map((o, i) => {
            colGroups.push(<col width={o.width || this.props.minWidth}></col>);
        });

        return <div className="fp-table-scroll-wrap">
            <div className="fp-table-scroll-content" onScroll={this.onScroll} ref={o => {
                tableWrapWidth = $(o).width();
            }}>
                <div className={cls.join(' ')} style={this.props.style || {}}>
                {/* ltable*/}
                    <table className='fp-table fp-head-table'>
                        <colgroup>{colGroups}</colgroup>
                        <thead>
                            <tr style={rowStyle && rowStyle[0] ? rowStyle[0] : {}}>
                                {
                                    data.struct.map((o, i) => {
                                        return <th className={o.className || ''}>
                                            {
                                                typeof o.title === 'function' ? o.title.call(this, o, i) : o.title
                                            }
                                        </th>;
                                    })
                                }
                            </tr>
                        </thead>
                    </table>
                    <div className="fp-table-content-wrap" style={{
                        height: this.props.initHeight,
                        'overflow-y': this.props.initHeight ? 'auto' : 'visible'
                    }}>
                        <table className='fp-table fp-table-fixed-head-body'>
                            <colgroup>{colGroups}</colgroup>
                            <tbody>
                                {
                                    data.data.length ? data.data.map(function (o, i) {
                                        var cls = [];
                                        if (data.stripe && i % 2) {
                                            cls.push('fp-stripe');
                                        }
                                        if (i == data.data.length - 1 && !o.subData) {
                                            cls.push('fp-table-last-tr');
                                        }

                                        var subCls = [];
                                        if (data.showSubData) {
                                            subCls.push('fp-subTable-show');
                                        } else {
                                            subCls.push('fp-subTable-hide');
                                        }

                                        var iconCls = ['fp-icon'];
                                        if (this.state.showSubDataArr[i]) {
                                            iconCls.push('fp-icon-expand');
                                        } else {
                                            iconCls.push('fp-icon-collapse');
                                        }

                                        var subData = {
                                            struct: data.subStruct,
                                            data: o.subData
                                        };
                                        return [<tr className={cls.join(' ')} data-index={i}>
                                            {
                                                data.struct.map(function (p, index) {
                                                    if (p.key === 'collapse' && o.subData) {
                                                        return <td className={p.className || ''}>
                                                            <span onClick={this.toggleRow.bind(this, i)} className={iconCls.join(' ')}></span>
                                                        </td>;
                                                    }
                                                    return <td className={p.className || ''}>
                                                        {typeof p.key == 'function' ? p.key.call(this, o, i, index, p) : o[p.key]}
                                                    </td>;
                                                }.bind(this))
                                            }
                                        </tr>,
                                        <tr className={subCls.join(' ')} style={{ height: this.state.showSubDataArr[i] ? 'auto' : 0 }}>
                                            {
                                                this.state.showSubDataArr[i] && o.subData
                                                    ? <td colSpan={data.struct.length}>{o.subData.call(this, o, i)}</td>
                                                    : null
                                            }
                                        </tr>];
                                    }.bind(this))
                                        : <tr>
                                            <td colSpan={data.struct.length} style={{
                                                width: '100%',
                                                "border-bottom": 0
                                            }}>
                                                {this.props.emptyText || '未查询到数据'}
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>;
    }
});

module.exports = CollapseTable;



// WEBPACK FOOTER //
// ./component/table/collapseTable.js